import { useQuery } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

// Every charting call placed for this payer — the detail page's collapsed
// "Charting calls" debug log, decoupled from which map version is selected.
export function useChartingRuns(payerId: string | null) {
  const query = useQuery({
    queryKey: payerKeys.chartingRuns(payerId ?? ''),
    queryFn: () => payersApi.listChartingRuns(payerId as string),
    enabled: !!payerId,
  });
  return { runs: query.data ?? [], isLoading: query.isLoading };
}
